import { useRequiredParams } from '@pba/react-router';
import { AppLayout } from 'layouts';
import { ChannelsEvents } from 'features/channels';
import { useGetPathToEntityDetail } from '../../hooks';
import { useNavigateToCalendar } from '../hooks';

const PageChannelsEvents = () => {
  const { organizationId } = useRequiredParams<{ organizationId: string }>();
  const getPathToEntityDetail = useGetPathToEntityDetail();
  const navigateToCalendar = useNavigateToCalendar();

  return (
    <AppLayout>
      <ChannelsEvents
        getPathToEventDetail={(id) => getPathToEntityDetail(id, { entityType: 'event' })}
        navigateToCalendar={navigateToCalendar}
        organizationId={organizationId}
      />
    </AppLayout>
  );
};

export default PageChannelsEvents;
